// extracted by mini-css-extract-plugin
export var imageWrapper = "join-to-facebook-group-module--image-wrapper--0196b";
export var wrapper = "join-to-facebook-group-module--wrapper--f78ef";